'use strict';

var Link = require('../Link');
var getManageData = require('../../models/manage-urls');

function renderManageLinks(depsArg) {
	var manageData = getManageData.getManageData(depsArg);
	var _ = depsArg.underscore;
	var user,
		roles,
		company,
		channel;

	function getCapabilities(config) {
		user = config.UserInfo || {};
		roles = user.roles || [];
		company = config.CompanyInfo || {};
		channel = config.CHANNEL_SETTINGS || {};
	}

	return {

		renderAccountLink: function render(config, deps) {
			getCapabilities(config);

			return (new Link({
				labelRaw: 'Account',
				urlSource: manageData.getAccountUrl(),
				isVisible: !company.onlyAdminsCanBuy || _.contains(roles, 'BILLING_ADMIN'),
				className: 'account-link admin-item', // For MyAppsController.js
				id: 'account' // For MyAppsController.js
			})).render(config, deps);
		},

		renderChannelLink: function render(config, deps) {
			getCapabilities(config);

			return (new Link({
				labelRaw: 'channel',
				urlSource: manageData.getChannelUrl(config),
				isVisible: _.intersection(roles, ['CHANNEL_ADMIN', 'CHANNEL_SUPPORT', 'CHANNEL_PRODUCT_SUPPORT', 'SALES_SUPPORT']).length
			})).render(config, deps);
		},

		renderCorporateLink: function render(config, deps) {
			getCapabilities(config);

			return (new Link({
				labelRaw: 'corporate',
				urlSource: manageData.getCorporateUrl(),
				isVisible: _.contains(roles, 'CORPORATE_ADMIN')
			})).render(config, deps);
		},

		renderInsightLink: function render(config, deps) {
			getCapabilities(config);
			var myAppsData = config && config.myapps && config.myapps.content || {};
			var insightApp = _.findWhere(myAppsData, { universalNavigatorProductType: 'APPINSIGHT' });

			return (new Link({
				labelRaw: 'Insights',
				urlSource: manageData.getInsightUrl(insightApp),
				isVisible: !!insightApp
			})).render(config, deps);
		},


		renderDeveloperLink: function render(config, deps) {
			getCapabilities(config);

			var link = new Link({
				labelRaw: (_.contains(roles, 'CHANNEL_ADMIN') && company.vendor) ? 'BillingAndDistribution' : 'Developer',
				urlSource: manageData.getDeveloperUrl(),
				isVisible: _.contains(channel.capabilities, 'DEVELOPER') && channel.cmsEnabled && company.vendor && _.contains(roles, 'DEVELOPER'),
				id: 'developer' // For MyAppsController.js
			});

			return link.render(config, deps);
		},

		renderResellerLink: function render(config, deps) {
			getCapabilities(config);

			return (new Link({
				labelRaw: 'reseller',
				urlSource: manageData.getResellerUrl(),
				isVisible: _.intersection(roles, ['RESELLER_MANAGER', 'RESELLER', 'REFERRAL']).length
			})).render(config, deps);
		},

		renderSuperuserLink: function render(config, deps) {
			getCapabilities(config);

			return (new Link({
				labelRaw: 'appdirectadmin',
				urlSource: manageData.getSuperUserUrl(config),
				isVisible: _.intersection(roles, ['SUPERUSER', 'SUPER_SUPPORT']).length,
				className: 'superuser-link'
			})).render(config, deps);
		}
	};
}

module.exports = {
	renderManageLinks: renderManageLinks
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/links/manage-links.js
// module id = 8
// module chunks = 0